import { ChangeEvent, Fragment, useState } from "react";
import {
  Box,
  Grid,
  Hidden,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import moment from "moment";
import Moment from "react-moment";
import Pagination from "@material-ui/lab/Pagination";
import { PromoUserWinner } from "types";
import {useStyles} from "./winners.style";

export const WinnerList: React.FC<{ items: PromoUserWinner[] }> = ({
  items = [],
}) => {
    const classes = useStyles();

  const [page, setPage] = useState<number>(1);
  const perPage = 6;

  const sortDate = (arr: PromoUserWinner[]) =>
    arr.sort((row1, row2) => {
      const k1 = moment(row1.created_at);
      const k2 = moment(row2.created_at);
      if (k1 < k2) return 1;
      if (k2 < k1) return -1;
      return 0;
    });

  return (
    <Fragment>

      <Table className="table animated fadeIn faster">
        <TableHead>
            {items.length > 0 &&<TableRow>
            <Hidden xsDown>
              <TableCell style={{color:'#323E48'}}>Дата</TableCell>
              <TableCell style={{color:'#323E48'}}>Телефон</TableCell>
              <TableCell style={{color:'#323E48'}}>Приз</TableCell>
            </Hidden>
          </TableRow>}
        </TableHead>
        <TableBody>
          {items.length > 0 &&
            sortDate(items)
              .slice(perPage * (page - 1), page * perPage)
              .map((i: PromoUserWinner, idx: number) => {
                const { lottery_period:{action_at}, prize, user } = i;

                return (
                  <TableRow key={idx} className={'rows'}>
                    <Hidden xsDown>
                      <Fragment key={idx}>
                        <TableCell>
                          <Moment>{action_at}</Moment>
                        </TableCell>
                        <TableCell>{user?.phone_secure}</TableCell>
                        <TableCell>{prize?.name}</TableCell>
                      </Fragment>
                    </Hidden>

                    <Hidden smUp>
                      <TableCell key={idx}>
                        <Box textAlign="left" fontSize={14}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Grid container>
                                <Grid item>
                                  <Box color="#323E48" fontSize={16} pb={1 / 4}>
                                    Дата розыгрыша
                                  </Box>
                                </Grid>
                                <Grid item xs={12} style={{fontSize:18}} className="nowrap_txt">
                                    <b><Moment>{action_at}</Moment></b>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container>
                                <Grid item>
                                  <Box color="#323E48" fontSize={16} pb={1 / 4}>
                                    Телефон
                                  </Box>
                                </Grid>
                                <Grid item xs={12} style={{fontSize:18}} className="nowrap_txt">
                                    <b>{user?.phone_secure}</b>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container>
                                <Grid item>
                                  <Box color="#323E48" fontSize={16} pb={1 / 4}>
                                    Приз
                                  </Box>
                                </Grid>
                                <Grid item xs={12} style={{fontSize:18}} className="nowrap_txt">
                                    <b>{prize?.name}</b>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </TableCell>
                    </Hidden>
                  </TableRow>
                );
              })}
        </TableBody>
      </Table>
      {items?.length > perPage && (
        <Box pt={4} textAlign="center">
          <Pagination
              className={classes.paginator}
            page={page}
            variant="text"
            count={Math.ceil(items?.length / perPage)}
            onChange={(_: ChangeEvent<unknown>, value: number) =>
              setPage(value)
            }
          />
        </Box>
      )}
    </Fragment>
  );
};
